import styled from 'styled-components';
import { Space } from 'antd';

export const TagSpace = styled(Space)`
  .ant-space-item {
    display: flex;
  }
`;
